import { render, staticRenderFns } from "./OzakazkaPendingItems.vue?vue&type=template&id=41f5bd42&"
import script from "./OzakazkaPendingItems.vue?vue&type=script&lang=ts&"
export * from "./OzakazkaPendingItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports